/* @flow */
import * as React from 'react';
import URI from 'urijs';

import Button from 'components/ButtonDeprecated';
import Link from 'components/Link';
import Image from 'components/Image';
import Text from 'components/Text';
import Glyph from 'components/Glyph';
import Row from 'components/Row';
import openUrl from 'utils/openUrl';
import { mountModal } from 'lib/modal';
import LinkedContentPreviewModal from 'components/LinkedContentPreviewModal';
import EventTracking from 'lib/EventTracking';

import './styles/ComposerLinkPreview.scss';

type Props = {
  linkPreview: *,
  onRemove: () => void,
};

class ComposerLinkPreview extends React.Component<Props> {
  getHostForUrl(url: string) {
    return URI(url).hostname() || URI(`http://${url}`).hostname();
  }

  openContent = () => {
    EventTracking.track('composer.little_preview.click', {
      action: 'click',
      element: 'little_preview',
      screen: 'composer',
    });

    const { linkPreview } = this.props;
    const { downloadPreview, url } = linkPreview;
    if (downloadPreview) {
      mountModal(<LinkedContentPreviewModal linkedContent={linkPreview} />, this);
    } else {
      openUrl(url);
    }
  };

  handleRemove = () => {
    const { onRemove } = this.props;

    EventTracking.track('composer.little_preview.x.click', {
      action: 'click',
      element: 'x',
      screen: 'composer',
      component: 'little_preview',
    });

    onRemove();
  };

  render() {
    const { linkPreview } = this.props;
    return (
      <div className="ComposerLinkPreview">
        <Link className="ComposerLinkPreview-thumbnail" onClick={this.openContent}>
          <Image
            className="ComposerLinkPreview-thumbnail-image"
            src={linkPreview.image}
            disableUserInteraction
          />
        </Link>
        <div className="ComposerLinkPreview-text">
          <Row size="xsmall">
            <Link onClick={this.openContent}>
              <Text
                className="ComposerLinkPreview-text-title"
                size="xsmall"
                truncate
                weight="semibold"
                wrap={false}
                color="mascot"
                align="left">
                {linkPreview.title || linkPreview.url}
              </Text>
            </Link>
            {linkPreview.title && linkPreview.description && (
              <Text color="graphite" size="xxxsmall" truncate wrap={false}>
                {linkPreview.description}
              </Text>
            )}
          </Row>
          <Text color="percussion" size="xxxxxsmall">
            {this.getHostForUrl(linkPreview.url)}
          </Text>
        </div>
        <Button
          aria-label="Close"
          className="ComposerLinkPreview-close"
          level="icon"
          weight="normal"
          onClick={this.handleRemove}>
          <Glyph name="close" size="small" />
        </Button>
      </div>
    );
  }
}

export default ComposerLinkPreview;
